import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Nav from './Component/Nav';
import Footer from './Component/Footer';
import Home from './Component/Home';
import WhoweAre from "./Component/WhoweAre";
import Contactus from "./Component/Contactus";
import Resources from "./Component/Resources";
// import PlacementStudentsPage from "./Component/PlacementStudentsPage";
import WebApplications from "./Component/WebApplications";
import MobileApp from "./Component/MobileApp";
import Jobs from "./Component/Jobs";
import GalleryPage from './Component/GalleryPage';
import HumanResource from "./Component/HumanResource";
import Showcase from "./Component/Showcase";
import Specialty from "./Component/Specialty";
import Outdoor from "./Component/Outdoor";
import SignUp from "./Component/SignUp";
import Aerospace from "./Component/Aerospace";
import AboutAll from "./Component/AboutAll";
import AboutUsSustainbility from "./Component/AboutUsSustainbility";
import AboutusDiversityInclusion from "./Component/AboutusDiversityInclusion";
import AboutLeadership from "./Component/AboutLeadership";
import FirstVale from "./Component/FirstVale";
import AboutParnerspage from "./Component/AboutParnerspage";
import AboutQuality from "./Component/AboutQuality";
import Aboutawards from "./Component/Aboutawards";
import Digitaltwin from "./Component/Digitaltwin";
import Socialresponsebilites from "./Component/Socialresponsebilites";
import NewandEvents from "./Component/NewandEvents";
import Poadcost from "./Component/Poadcost";
import GlobalOffices from "./Component/GlobalOffices";
import Scrolltriangle from "./Component/Scrolltriangle";
import ChatBox from "./Component/ChatBox"; // Import ChatBox
// import Leadershipdata from "./Component/Leadershipdata";
import CaseStudies from "./Component/CaseStudies";
import AutomotiveandMobility from "./Component/AutomotiveandMobility";
import CommunicationPage from "./Component/CommunicationPage";
import EnergyPage from "./Component/EnergyPage";
import HealthCarepage from "./Component/HealthCarepage";
import MiningPage from "./Component/MiningPage";
import RaitransportainPage from "./Component/RaitransportainPage";
import SemiconductorsPage from "./Component/SemiconductorsPage";
import UtilitesPage from "./Component/UtilitesPage";
import DigitalPage from "./Component/DigitalPage";
import EngineeringPage from "./Component/EngineeringPage";
import ManufacturingPage from "./Component/ManufacturingPage";
import GeospatialPage from "./Component/GeospatialPage";
import EnterpriceprivateNetworks from "./Component/EnterpriceprivateNetworks";
import Leadershipdatatwo from "./Component/Leadershipdatatwo";
import CarrersPage from "./Component/CarrersPage";
import CasestudyCustomersuccestory from "./Component/CasestudyCustomersuccestory";
import DigitalManufacturingPage from "./Component/DigitalManufacturingPage";
import Caselinedesignpage from "./Component/Caselinedesignpage";
import Casestudiesteamcenterpage from "./Component/Casestudiesteamcenterpage";
import Itreickpage from "./Component/Itreickpage";
import Inteligentmobilitypage from "./Component/Inteligentmobilitypage";
import UbstrationPage from "./Component/UbstrationPage";
import Talsktous from "./Component/Talsktous";
import Leadershipdatathree from "./Component/Leadershipdatathree";
import MechanicalEngineeringpage from "./Component/MechanicalEngineeringpage";
import Embeddedsystems from "./Component/Embeddedsystems";

import MechanicalHiringpage from "./Component/MechanicalHiringpage";
import Digitalmarketinpage from "./Component/Digitalmarketinpage";
import Ithiringpage from "./Component/Ithiringpage";
import Itengineeringpage from "./Component/Itengineeringpage";

import Communication from "./Component/Communication";
import EnergyPagedata from "./Component/EnergyPagedata";
import Documentaerospacepage from "./Component/Documentaerospacepage";
import DocumentHealthcarePage from "./Component/DocumentHealthcarePage";
import DocumentBfsipage from './Component/DocumentBfsipage';
import Documnetmanufacturepage from "./Component/Documnetmanufacturepage";
import DocumentAutomotivaPage from "./Component/DocumentAutomotivaPage" ;
import DocumnetEnergyPage from "./Component/DocumnetEnergyPage"; 
//   new importing files for the drebcon project 

import DocumentCommunicationPage from "./Component/DocumentCommunicationPage";
import LeadershipDatasecond from "./Component/LeadershipDatasecond";

import Leadershipnagmohan from "./Component/Leadershipnagmohan";
import Leadershirajareddy from "./Component/Leadershirajareddy";

import Leadersjyoheswarreddy from "./Component/Leadersjyoheswarreddy";
 

function App() {
  return (
    <div>
      <Router>
        <Scrolltriangle />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/who-we-are" element={<WhoweAre />}></Route>
          <Route path="/contact" element={<Contactus />}></Route>
          <Route path="/gellerypage" element={<GalleryPage />} />
          {/* <Route path="/placed-students" element={<PlacementStudentsPage />} /> */}
          <Route path="/snowcsc" element={<Showcase />} />
          <Route path="/Specialty" element={<Specialty />} />
          <Route path="/Outdoor" element={<Outdoor />} />
          <Route path="/custom-applications" element={<Resources />} />
          <Route path="/web-applications" element={<WebApplications />} />
          <Route path="/mobile-application" element={<MobileApp />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/human-resource" element={<HumanResource />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/aerospace" element={<Aerospace />} />
          <Route path="/aboutenvision" element={<AboutAll />} />
          <Route path="/aboutsustainability" element={<AboutUsSustainbility />} />
          <Route path="/aboutdiversity" element={<AboutusDiversityInclusion />} />
          <Route path="/aboutleadership" element={<AboutLeadership />} />
          <Route path="/firstvalue" element={<FirstVale />} />
          <Route path="/aboutpartnerspage" element={<AboutParnerspage />} />
          <Route path="/aboutquality" element={<AboutQuality />} />
          <Route path="/aboutawords" element={<Aboutawards />} />
          <Route path="/digitaltwin" element={<Digitaltwin />} />
          <Route path="/socialresponsibilites" element={<Socialresponsebilites />} />
          <Route path="/newsandevents" element={<NewandEvents />} />
          <Route path="/podcasts" element={<Poadcost />} />
          <Route path="/globaloffices" element={<GlobalOffices />} />
          {/* <Route path="/leadershipdata" element={<Leadershipdata />} /> */}
          <Route path="/casestudies" element={<CaseStudies />} />
          <Route path="/automotivemobility" element={<AutomotiveandMobility />} />
          <Route path="/communication" element={<CommunicationPage />} />
          <Route path="/energy" element={<EnergyPage />} />
          <Route path="/healthcare" element={<HealthCarepage />} />
          <Route path="/minning" element={<MiningPage />} />
          <Route path="/railtransportaion" element={<RaitransportainPage />} />
          <Route path="/semiconductors" element={<SemiconductorsPage />} />

          <Route path="/utilities" element={<UtilitesPage />} />
          <Route path="/digital" element={<DigitalPage />} />
          <Route path="/engineeringpage" element={<EngineeringPage />} />
          <Route path="/manufacturingpage" element={<ManufacturingPage />} />
          <Route path="/geospatialpage" element={<GeospatialPage />} />
          <Route path="/enterpriceprivatenetworks" element={<EnterpriceprivateNetworks />} />
          <Route path="/leadershipmd" element={<Leadershipdatatwo />} />
          <Route path="/carrerspage" element={<CarrersPage />} />
          <Route path="/casestudysuccesstory" element={<CasestudyCustomersuccestory />} />
          <Route path="/digitalmanufaturingcasestudy" element={<DigitalManufacturingPage />} />
          <Route path="/linedesignpage" element={<Caselinedesignpage />} />
          <Route path="/teamcenterpage" element={<Casestudiesteamcenterpage />} />
          <Route path="/itrickpage" element={<Itreickpage />} />
          <Route path="/inteligentriskpage" element={<Inteligentmobilitypage />} />
          <Route path="/ubstrationpage" element={<UbstrationPage />} />
          <Route path="/talktous" element={<Talsktous />} />
          <Route path="/leadershipdatathree" element={<Leadershipdatathree />} />
          <Route path="/mechanicalengineering" element={<MechanicalEngineeringpage />} />
          <Route path="/embeddedsystems" element={<Embeddedsystems />} />
          <Route path="/mechanicalHiringpage" element={<MechanicalHiringpage />} />
          <Route path="/digitalmarketinpage" element={<Digitalmarketinpage />} />
          <Route path="/ithiringpage" element={<Ithiringpage />} />
          <Route path="/itengineeringpage" element={<Itengineeringpage />} />
          <Route path="/communication" element={<Communication />} />
          <Route path="/energyPagedata" element={<EnergyPagedata />} />
          <Route path="/documentaerospacepage" element={<Documentaerospacepage />} />
          <Route path="/documentaerospacepage" element={<Documentaerospacepage />} />
          <Route path="/documentHealthcarePage" element={<DocumentHealthcarePage />} />
          <Route path="/documentBfsipage" element={<DocumentBfsipage />} />
          <Route path="/documnetmanufacturepage" element={<Documnetmanufacturepage />} />
          <Route path="/documentAutomotivaPage" element={<DocumentAutomotivaPage />} />
          <Route path="/documnetEnergyPage" element={<DocumnetEnergyPage />} />
          <Route path="/documentCommunicationPage" element={<DocumentCommunicationPage />} />

          <Route path="/leadershipDatasecond" element={<LeadershipDatasecond />} />
          <Route path="/leadershipnagmohan" element={<Leadershipnagmohan />} />
          <Route path="/leadershir" element={<Leadershirajareddy />} />

          <Route path="/ledersjyohesh" element={<Leadersjyoheswarreddy />} />
          
          
          
         
          
          
        </Routes>

        <ChatBox /> {/* Add ChatBox here to appear on every page */}
     
      </Router>
    </div>
  );
}

export default App;
